// Freight Cost list: GET /procurement/getall-list-freight-cost query builder
// and the Excel/CSV export. Fetch and download helpers are shared with the
// Plan & Procurement list.

import { api } from '../../../config';
import { formatDateToDDMMYYYY } from '../../../utils/dateformatter';
import { downloadSheet } from '../../Procurement/utils/procurementList';
import { getListProductTypeLabel } from '../../../shared/offer-domain/constants';

export const FREIGHT_PROCUREMENT_TYPE_MAP = {
  '': '-',
  PelelanganKhusus: 'Pelelangan Khusus',
  PemilihanLangsung: 'Pemilihan Langsung',
  TunjukLangsung: 'Tunjuk Langsung',
};

// Column id -> SortBy value. Ids without an entry are sent as-is.
export const FREIGHT_SORT_FIELDS = {
  procurementnumber: 'procurementnumber',
  titleprocurement: 'titleprocurement',
  procurementtype: 'procurementtype',
  description: 'description',
  isProcurementCompleted: 'isProcurementCompleted',
};

export const DEFAULT_SORT_FIELD = 'freightRequestDate';

// Status metadata for the freight cost list stat cards and dropdown. The id is
// the tab key used by `matchesFreightStatus` ('' = no status filter).
export const FREIGHT_STATUS_TABS = [
  {
    id: 'notAvailable',
    label: 'Not Available',
    icon: 'ri-close-circle-line',
  },
  {
    id: 'available',
    label: 'Available',
    icon: 'ri-checkbox-circle-line',
  },
];

export const DEFAULT_STATUS_TAB = '';

export const isFreightAvailable = row => row?.freightCostStatus === 'Available';

// The list endpoint ignores status query params, so filtering happens on the
// client against the row's freightCostStatus ('' = no status filter).
export const matchesFreightStatus = (row, tabId) => {
  if (tabId === 'available') return isFreightAvailable(row);
  if (tabId === 'notAvailable') return !isFreightAvailable(row);
  return true;
};

export const buildFreightListUrl = ({
  currentPage,
  rowsPerPage,
  search,
  sortField,
  sortDirection,
}) => {
  const params = new URLSearchParams();
  params.set('PageNumber', String(currentPage));
  params.set('PageSize', String(rowsPerPage));
  if (search?.trim()) params.set('Search', search.trim());
  if (sortField) {
    params.set('SortBy', sortField);
    params.set('IsDescending', sortDirection === 'desc' ? 'true' : 'false');
  }
  return `${api.API_URL}/procurement/getall-list-freight-cost?${params.toString()}`;
};

const toExportRow = row => ({
  'ID Proc': row.procurementNumber || '',
  'Requested Date': formatDateToDDMMYYYY(row.freightRequestDate) || '',
  'Freight Cost No': row.freightRequestNumber || '',
  Title: row.titleProcurement || '',
  'Proc Type': FREIGHT_PROCUREMENT_TYPE_MAP[row.procurementType] || '',
  Product: row.productType?.name || '',
  'Product Type':
    getListProductTypeLabel(row, row.productType?.description) || '',
  Description: row.description || '',
  Status: row.freightCostStatus || '',
});

export const exportFreightList = (rows, { format, sheetName }) =>
  downloadSheet(rows.map(toExportRow), {
    format,
    prefix: 'FreightCost',
    sheetName,
  });
